export interface INotificationData {
  onMessageClick?: () => void;
}

export enum ENotificationStatus {
  NEW = 'new',
  SEEN = 'seen',
  OPENED = 'opened'
}

export enum ENotificationGroups {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  '7_DAYS' = '7-days',
  OLDER = 'older'
}

export interface INotification {
  id: string;
  title?: string;
  message: string;
  messageType: string;
  createdAt: string;
  deletedAt?: string;
  metadata?: any;
  receiveId: string;
  notificationCategoryId: string;
  sourceType?: string;
  status: ENotificationStatus;
  type: 'manager' | 'customer';
  updatedAt: string;
}
